export interface ConnectionsModalState {
  isOpen?: boolean
}

export interface ConnectionsModalContextProps extends ConnectionsModalState {
  toggleModal: () => void
}

export enum ConnectionsModalActionTypes {
  TOGGLE_MODAL = 'TOGGLE_MODAL',
}
